<template>
  <div class="border-layout" style="width: 1100px">
    <div>
      <div class="p-fluid p-grid">
        <div class="p-field p-col-12 p-md-2 p-input-filled">
          <label for="number">Изписване №</label>
          <InputText id="number" type="text" v-model="data.number" readonly tabindex="-1" aligh="right"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="date">Дата</label>
          <Calendar id="date" :showIcon="true" v-model="date"/>
          <small class="p-invalid" v-if="submitted && !data.date">Полето е задължително.</small>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="store">Склад / търговски обект</label>
          <AutoComplete v-model="data.store" :dropdown="true" field="name"
            :suggestions="stores" @complete="searchStore($event)" placeholder="Въведете група"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="store">&nbsp;</label>
          <ToggleButton v-model="issueInvoice" onLabel="Издай фактура" offLabel="Без фактура" onIcon="pi pi-check" offIcon="pi pi-times"/>
        </div>
      </div>
    </div>
    <DataTable :value="data.items"
        dataKey="pos"
        :rowHover="true"
        :scrollable="true"
        scrollHeight="flex"
        @row-select="onItemSelect"
        selectionMode="single"
        ref="table"
        style="height: calc(100vh - 350px)"
        v-model:selection="tbl.selectedItems"
        class="p-datatable-striped p-datatable-sm"
        showGridlines>
      <template #header>
        <div class="table-header">
          <h3 class="p-m-0">Изписани стоки/материали</h3>
          <span class=p-buttonset>
            <Button
                label="Добави"
                icon="pi pi-plus"
                class="p-button-success"
                @click="onItemCreate"
            />
            <Button
                label="Редактирай"
                icon="pi pi-pencil"
                class="p-button-primary"
                @click="onItemEdit"
                :disabled="!tbl.selected"
            />
            <Button
                label="Изтрий"
                icon="pi pi-trash"
                class="p-button-danger"
                @click="onItemDelete"
                :disabled="!tbl.selected"
            />
          </span>
        </div>
      </template>
      <Column field="pos" header="№" style="flex: 0 0 3em" bodyClass="right">
        <template #body="props">
          {{props.index + 1 + '.'}}
        </template>
      </Column>
      <Column field="product" header="Код" style="flex: 0 0 7em">
        <template #body="props">
          {{props.data.product ? props.data.product.number: ''}}
        </template>
      </Column>
      <Column field="product" header="Наименование">
        <template #body="props">
          {{props.data.product ? props.data.product.name : ''}}
        </template>
        <template #footer>
          Общо {{count}} записа
        </template>
      </Column>
      <Column field="quantity" header="К-во" style="flex: 0 0 4em" bodyClass="right">
        <template #body="props">
          {{$utils.value(props.data.quantity)}}
        </template>
      </Column>
      <Column field="measure" header="Мярка" style="flex: 0 0 5em" bodyClass="center">
        <template #body="props">
          {{props.data.product ? props.data.product.measure : ''}}
        </template>
      </Column>
      <Column field="vatPerc" header="ДДС %" style="flex: 0 0 6em" bodyClass="right">
        <template #body="props">
          {{$utils.value(props.data.vatPerc)}}
        </template>
      </Column>
    </DataTable>
  </div>

  <ConsumptionItem @load="onItemLoad" @save="onItemSave" v-model:visible="tbl.edit"
    v-model:data="tbl.selected" title="Изписване на стока"/>

</template>

<script>
export default {
  data() {
    var model = this.modelValue;
    var document = {contragent: {}, store: {}, items: [], properties: {}};
    if (model) {
      document = model;
      if (!document.contragent) {
        document.contragent = model.contragent;
      }
      if (!document.store) {
        document.store = model.store;
      }
      if (!document.items) {
        document.items = model.items;
      }
      if (!document.propertie) {
        document.properties = model.properties;
      }
    }
    return {
      data: document,
      editing: null,
      stores : [],
      contragents : [],
      products : [],
      editingRows: [],
      submitted: false,
      importerVisible: false,
      tbl: {
        selected: null,
        selectedItems: [],
        edit: false,
      }
    }
  },

  props: {
    modelValue: Object
  },
  mounted() {
    if(this.data) {
      if (this.data.items) {
        var pos = 1;
        for(var item of this.data.items) {
          item.pos = pos++;
        }
      } else {
        this.data.items = [];
      }
      if (!this.data.properties) {
        this.data.properties = {}
      }
    }
  },
  emits: ['update:modelValue'],
  methods: {
    forceUpdate(event) {
      this.$emit('input', event.target.value)
    },
    searchStore(event) {
      var ctx = this;
      this.$http.get('/store', {
        params: {
          query: event.query
        }
      }).then(res => ctx.stores = res.data)
    },
    searchContragent(event) {
      var ctx = this;
      this.$http.get('/contragent', {
        params: {
          query: event.query
        }
      }).then(res => ctx.contragents = res.data)
    },
    onItemLoad(data) {
      data.sale = this.data;
      data.data = {}
      data = data.data;
      if (this.tbl.selected) {
        var value = this.$utils.value;
        data.product  = this.tbl.selected.product;
        data.batch  = this.tbl.selected.batch;
        data.quantity  = value(this.tbl.selected.quantity);
        data.price  = value(this.tbl.selected.price);
        data.vatPerc  = value(this.tbl.selected.vatPerc);
        data.discountPerc  = value(this.tbl.selected.discountPerc);
      }
    },
    onItemSave(data) {
      var selected = false;
      if (this.tbl && this.tbl.selected != null && this.tbl.selected) {
        selected = true;
      }
      if(!selected) {
        var pos = 1;
        for (var i of this.data.items) {
          if (pos <= i.pos) {
            pos = i.pos + 1;
          }
        }
        this.data.items.push(
          this.tbl.selected = {
            pos: pos,
            product: null
          }
        )
      }
      for(var k in data) {
        this.tbl.selected[k] = data[k];
      }
      this.tbl.selectedItems = this.tbl.selected;
      this.calculate()
    },
    onItemSelect(data) {
      this.tbl.selected = data.data;
    },
    onItemEdit() {
      this.tbl.edit = true;
    },
    onItemCreate() {
      this.tbl.selected = null;
      this.tbl.selectedItems = null;
      this.tbl.edit = true;
    },
    onItemDelete() {
      this.data.items = this.data.items.filter(val => val != this.tbl.selected);
      this.tbl.selected = null;
    },
    onSave(event) {
      event.onSuccess();
    },
    onSelectContragent(data) {
      this.data.contragent = data;
    },
    sum(f) {
      var total = 0;
      if(this.data && this.data.items) {
        for(const item of this.data.items) {
          total += this.$utils.value(f(item));
        }
      }
      return total;
    },
    calculateItem(item) {
      item.netto = (this.$utils.value(item.quantity) *  this.$utils.value(item.price)).toFixed(2);
      //var discount = netto * this.$utils.value(this.data.vatPerc) / 100;
      item.vat = (item.netto * (this.vatPerc / 100)).toFixed(2);
      item.total = item.netto + item.vat;
    },
    calculate() {
      if(this.data && this.data.items) {
        for(var item of this.data.items) {
          this.calculateItem(item);
          item.vatPerc = this.vatPerc;
          item.vat = this.$utils.value(item.netto) * (item.vatPerc / 100);
          item.total = this.$utils.value(item.netto) * (1 + item.vatPerc / 100);
        }
      }
    }
  },
  computed: {
    netto: function() {
      return this.sum( item => item.netto );
    },
    vat: function() {
      return this.sum( item => item.vat );
    },
    vatPerc: function() {
      return 20;
    },
    date: {
      get() {
        if (this.data && this.data.date) {
          if ((typeof this.data.date) == 'string') {
            return new Date(this.data.date);
          }
          return this.data.date;
        }
        return null;
      },
      set(date) {
        this.data.date = date;
      },
    },
    issueInvoice: {
      get() {
        if (this.data && this.data.properties) {
          return this.data.properties.issueInvoice;
        }
        return false;
      },
      set(issueInvoice) {
        if(!this.data.properties) {
          this.data.properties = {}
        }
        var change = this.data.properties.issueInvoice != issueInvoice;
        this.data.properties.issueInvoice = issueInvoice;
        if (change) {
          this.calculate();
        }
      },
    },
    total: function() {
      return this.sum( item => item.total );
    },
    count: function() {
      if (this.data && this.data.items) {
        return this.data.items.length;
      }
      return 0;
    }
  }
}
</script>
